import React, {Component} from 'react';
import PropTypes from "prop-types";
import InputField from "./InputField";

class SearchField extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        onSearch: PropTypes.func.isRequired
    };

    static defaultProps = {
        name: 'searchField',
        value: '',
        placeholder: null,
        disabled: false,
        onChange: null,
        onCancel: null,
        styles: null
    };

    constructor(props) {

        super(props);

        this.state = {
            name: (props.name) ? props.name : 'searchField',
            value: (props.value) ? props.value : ''
        };

        this.translate = this.props.baseData.translate;

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.saveValue = this.saveValue.bind(this);

    }

    componentWillMount() {

        const newState = {};

        //  userSettings laden.
        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};

        //  fieldValue aus den userSettings laden.
        const value = (settings[this.state.name]) ? settings[this.state.name] : '';

        if (value) newState.value = value;

        if (newState) {
            this.setState(newState);

            if (this.props.onSearch) this.props.onSearch(this.state.name, value);
        }

    }

    onFocus(event) {

        const value = event.target.value;

        event.target.value = '';
        event.target.value = value;

    }

    onBlur(event) {

        const value = event.target.value;

        if (value !== this.state.value) {
            this.props.onSearch(this.state.name, value);
            this.saveValue(this.state.name, value);
        }

    }

    onChange(event) {

        const value = event.target.value;

        if (this.props.onChange) this.props.onChange(value);

        this.setState({value});

    }

    onKeyDown(event) {

        if (event) {
            if (event.keyCode === 13) { //  Return
                if (this.props.onSearch) {
                    this.props.onSearch(this.state.name, this.state.value);
                    this.saveValue(this.state.name, this.state.value);
                }
            } else if (event.keyCode === 27) {  //  Esc
                if (this.props.onSearch) this.props.onSearch(this.state.name, '');
                if (this.props.onCancel) this.props.onCancel();

                this.saveValue(this.state.name, '');

                this.setState({
                    value: ''
                });
            }
        }

    }

    saveValue(name, value) {

        if (this.props.baseData.saveSettings) this.props.baseData.saveSettings(name, value);

    }

    render() {

        const fieldName = (this.state.name) ? this.state.name : 'searchField';
        const inputValue = this.state.value;
        const inputPlaceholder = (this.props.placeholder) ? this.props.placeholder : this.translate('searching') + '...';
        const inputDisabled = this.props.disabled;
        const styles = this.props.styles;

        return (
            <span className="searchField" style={styles}>
                <InputField
                    name={fieldName}
                    value={inputValue}
                    placeholder={inputPlaceholder}
                    disabled={inputDisabled}
                    onFocus={(event) => this.onFocus(event)}
                    onBlur={(event) => this.onBlur(event)}
                    onChange={(event) => this.onChange(event)}
                    onKeyDown={(event) => this.onKeyDown(event)}
                />
            </span>
        );

    }

}

export default SearchField;